import { render, staticRenderFns } from "./VolunteerAllList.vue?vue&type=template&id=39986f04&scoped=true"
import script from "./VolunteerAllList.vue?vue&type=script&lang=js"
export * from "./VolunteerAllList.vue?vue&type=script&lang=js"
import style0 from "./VolunteerAllList.vue?vue&type=style&index=0&id=39986f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39986f04",
  null
  
)

export default component.exports